import { render, staticRenderFns } from "./Gallery3.vue?vue&type=template&id=3ee79157&scoped=true&"
import script from "./Gallery3.vue?vue&type=script&lang=js&"
export * from "./Gallery3.vue?vue&type=script&lang=js&"
import style0 from "./Gallery3.vue?vue&type=style&index=0&id=3ee79157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee79157",
  null
  
)

export default component.exports